<div class="full-height layout-column"
     [ngClass]="{
              'disabled-task': (task.analysis?.state == 'UnstartableDependent' || task.analysis?.state == 'UnstartableNoRoute'),
              'highlight-task': isHighlighted
              }">

  <!--Main Details-->
  <div class="flex layout-row">

    <!--    <div *ngIf="isMobile" class="flex-10 layout-column layout-align-center-center">-->
    <!--      <md-button class="md-icon-button margin-bottom-10" ng-click="$ctrl.onMoveUp()"-->
    <!--                 ng-disabled="!$ctrl.movement.canMoveUp">-->
    <!--        <md-icon ng-class="{'purpose-color': $ctrl.movement.canMoveUp}" md-svg-icon="chevron-up" class="md-20"-->
    <!--                 aria-label="Close"></md-icon>-->
    <!--      </md-button>-->
    <!--      <md-button class="md-icon-button margin-top-10" ng-click="$ctrl.onMoveDown()"-->
    <!--                 ng-disabled="!$ctrl.movement.canMoveDown">-->
    <!--        <md-icon ng-class="{'purpose-color': $ctrl.movement.canMoveDown}" md-svg-icon="chevron-down" class="md-20"-->
    <!--                 aria-label="Close"></md-icon>-->
    <!--      </md-button>-->
    <!--    </div>-->

    <!--Account | Account | Purpose-->
    <div class="flex-30 layout-row drag-container">

      <ng-content></ng-content>

      <div class="layout-row">
        <!--Purpose Color Div-->
        <div class="index-border" [ngClass]="task.taskSpec.purpose"></div>

        <!--Index & Checkbox-->
        <div *ngIf="task.taskType !== 'Internal' && !internalTaskPurposeTypes[task.taskSpec.purpose]"
             class="layout-column layout-align-center-center index-column">
          <span class="br-body-2 font-weight-700 margin-bottom-10">{{ task.analysis.daySequence }}</span>
          <bringoz-icon iconName="drag" classSize="sm" fill="#484848"></bringoz-icon>
        </div>

      </div>


      <div class="flex layout-column padding-5 text-ellipsis">

        <!--Checkbox & Purpose-->
        <div class="layout-row layout-align-start-center gap-5">
          <app-task-purpose class="text-ellipsis"
                            [isBundle]="task.taskType === 'BundledStopover'"
                            [purpose]="task.taskSpec.purpose">

          </app-task-purpose>

          <app-entity-relations-indicator [task]="task"></app-entity-relations-indicator>
          <bringoz-icon *ngIf="task.analysis.pinned"
                        iconName="location-pin-outline"
                        classSize="sm"
                        fill="#484848">

          </bringoz-icon>

        </div>

        <!--Service ID-->
        <div class="layout-row layout-align-start-center" layout="row" layout-align="start center">
          <!--          <span class="br-caption-1">{{task.serviceDisplayId || task.packageList[0].externalId || task.serviceId}}</span>-->
          <span class="br-caption-1">{{ task.serviceDisplayId || task.serviceId }}</span>
        </div>

        <!--Account-->
        <div class="layout-row layout-align-start-center">
          <span bringoz-ppi class="br-caption-2 text-ellipsis-multi-lines-3">{{ task.taskSpec.contact.name }}</span>
          <!--          <span bringoz-ppi class="br-caption-2 break-word">{{task.taskSpec.contact.name}}</span>-->
        </div>
      </div>

    </div>

    <div class="vr"></div>

    <!--Main Info-->
    <div class="flex layout-row padding-5">

      <div class="flex layout-column">

        <!--Time Window & ETA-->
        <div class="layout-row info-row">

          <!--Time Window-->
          <div class="flex layout-row layout-align-start-center gap-5">
            <bringoz-icon iconName="time-window-outline"
                          classSize="sm"
                          fill="#484848"
                          [ngbTooltip]="'Time Window' | translate"
                          openDelay="300">

            </bringoz-icon>

            <span class="br-caption-2"
                  [ngbTooltip]="'Due' | translate"
                  openDelay="300">
              {{ task.taskSpec | timeWindow }}
            </span>

          </div>

          <!--ETA-->
          <div class="flex-40 layout-row layout-align-start-center gap-5">
            <span
              translate>{{ task.status === 'CourierArrived' ? 'CourierArrived' : (task.status === 'CourierDeparted' ? 'Departed' : 'ETA') }}</span>

            <span [ngClass]="{'late': task.analysis.late > 0 }">
              {{ task.status === 'CourierArrived' ? ({eta: task.agentArrivalTime} | bringozTime: 'eta') : (task.status === 'CourierDeparted' ? {eta: task.taskSpec.trackingArrival?.ts} : {eta: task.analysis?.eta}) | bringozTime: 'eta' }}
            </span>
          </div>

        </div>

        <!--Address/service time-->
        <div class="layout-row layout-align-start-center">
          <div class="layout-row layout-align-start-center gap-5 info-row">
            <bringoz-icon iconName="location-pin-outline" classSize="sm" fill="#484848"></bringoz-icon>
            <span flex class="br-caption-2 text-ellipsis">{{ task.taskSpec.address | bringozAddress }}</span>
          </div>

          <div *ngIf="task.taskSpec.serviceTime || task.taskSpec.detailedServiceTime"
               class="layout-row layout-align-start-center margin-left-5 gap-5">
            <bringoz-icon iconName="timer-outline"
                          classSize="md"
                          fill="#484848">

            </bringoz-icon>
            <div *ngIf="!task.taskSpec.detailedServiceTime" layout="row"
                 layout-align="start center" class="md-tiny">
              {{ task.taskSpec.serviceTime | bringozTimeConvert: true }}
            </div>

            <app-task-detailed-service-time *ngIf="!!task.taskSpec.detailedServiceTime"
                                            class="margin-left-5"
                                            [fontSize]="'md-tiny'"
                                            [isAllowEdit]="false"
                                            [detailedServiceTime]="task.taskSpec.detailedServiceTime">
            </app-task-detailed-service-time>
          </div>
        </div>

        <!--Capacity Bars-->
        <div class="layout-row gap-10 info-row">

          <!--Weight-->
          <div class="layout-row layout-align-start-center gap-5">
            <bringoz-icon iconName="weight" classSize="sm" fill="#484848"></bringoz-icon>
            <app-bringoz-capacity-bar class="flex"
                                      [value]="task.analysis.currentLoad?.weightLoadPercent || 0">

            </app-bringoz-capacity-bar>
          </div>

          <!--Volume-->
          <div class="layout-row layout-align-start-center gap-5">
            <bringoz-icon iconName="volume" classSize="sm" fill="#484848"></bringoz-icon>
            <app-bringoz-capacity-bar class="flex"
                                      [value]="task.analysis.currentLoad?.dimensionsLoadPercent || 0">

            </app-bringoz-capacity-bar>
          </div>

          <!--Spots-->
          <div class="layout-row layout-align-start-center gap-5">
            <bringoz-icon iconName="spot" classSize="sm" fill="#484848"></bringoz-icon>
            <app-bringoz-capacity-bar class="flex"
                                      [value]="task.analysis.currentLoad?.numberOfSpotsLoadPercent || 0">

            </app-bringoz-capacity-bar>
          </div>

          <!--          <task-capacity-bars flex-->
          <!--                              current-load="::$ctrl.task.analysis.currentLoad?">-->

          <!--          </task-capacity-bars>-->
        </div>

      </div>

      <!--Status-->
      <div layout="column" layout-align="center center" class="info-row">
        <app-task-status [status]="task.status" small="true"></app-task-status>
      </div>

    </div>
  </div>


</div>
